exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tap-free[data-v-fbb13f2e]{margin-top:42px}.tap-free[data-v-fbb13f2e]::before{background:#f1f1f1}", "", {"version":3,"sources":["/home/hanzhu/nutstore-webpages/js_src_vue/src/pages/page_price_versions/components/Buy/BuyTapFree.vue?vue&type=style&index=0&id=fbb13f2e&lang=scss&scoped=true&"],"names":[],"mappings":"AAAA,2BAA2B,eAAe,CAAC,mCAAmC,kBAAkB,CAAC","file":"BuyTapFree.vue?vue&type=style&index=0&id=fbb13f2e&lang=scss&scoped=true&","sourcesContent":[".tap-free[data-v-fbb13f2e]{margin-top:42px}.tap-free[data-v-fbb13f2e]::before{background:#f1f1f1}"],"sourceRoot":""}]);

// exports
